import { APICore } from './apiCore'

const api = new APICore()

function getTiposVisitantes (params) {
  const baseUrl = '/tipos-visitante'
  return api.get(baseUrl, params)
}

function getTiposVisitante (id) {
  const baseUrl = `/tipos-visitante/${id}`
  return api.get(baseUrl, {})
}

function addTiposVisitante (params) {
  const baseUrl = '/tipos-visitante'
  return api.create(baseUrl, params)
}

function updateTiposVisitante (params) {
  const baseUrl = '/tipos-visitante'
  return api.update(baseUrl, params)
}

function deleteTiposVisitante (params) {
  const baseUrl = '/tipos-visitante'
  return api.delete(baseUrl, params)
}

export { getTiposVisitantes, getTiposVisitante, addTiposVisitante, updateTiposVisitante, deleteTiposVisitante }
